export const MANAGEFLAVOR = 'MANAGEFLAVOR'
export const MANAGEFLAVORTYPE = 'MANAGEFLAVORTYPE'
export const MANAGEINSTANCEREGION = 'MANAGEINSTANCEREGION'
export const MANAGEOBJECTSTORAGEREGION = 'MANAGEOBJECTSTORAGEREGION'
export const MANAGEZONE = 'MANAGEZONE'